/**
 * INSTITUTIONAL DEPTH V1 (LOT 1) — PullQuote : grande citation éditoriale.
 * MaskReveal (rideau GPU, motif signature des maisons éditoriales) + guillemets
 * typographiques français. Sobriété absolue : pas de fond, filet or en amorce.
 */
import React from 'react';
import { Reveal, MaskReveal } from '../../hooks/useScrollReveal';

export const PullQuote = ({ quote, attribution, tone = 'light', className = '', testid }) => {
  const dark = tone === 'dark';
  return (
    <figure className={`max-w-4xl ${className}`} data-testid={testid}>
      <Reveal effect="fade">
        <span className={`block w-12 h-px mb-8 ${dark ? 'bg-gold' : 'bg-gold-dark'}`} aria-hidden="true" />
      </Reveal>
      <blockquote>
        <MaskReveal delay={120}>
          <p className={`font-heading text-2xl md:text-3xl lg:text-[2.4rem] leading-[1.3] text-balance ${dark ? 'text-ivory' : 'text-charcoal'}`}>
            <span className={dark ? 'text-gold' : 'text-gold-dark'} aria-hidden="true">«&nbsp;</span>
            {quote}
            <span className={dark ? 'text-gold' : 'text-gold-dark'} aria-hidden="true">&nbsp;»</span>
          </p>
        </MaskReveal>
      </blockquote>
      {attribution && (
        <Reveal delay={340}>
          <figcaption className={`mt-6 text-[11px] tracking-[0.16em] uppercase font-medium ${dark ? 'text-ivory/60' : 'text-graphite/70'}`}>
            {attribution}
          </figcaption>
        </Reveal>
      )}
    </figure>
  );
};

export default PullQuote;
